import { TeambookCheckbox } from "../../default_components/TeambookCheckbox";
import PropTypes from "prop-types";

const HideMobileSwitch = ({ mobileHidden, setMobileHidden }) => {
  return (
    <>
      <div className="hide-mobile-component">
        Hide Mobile
        <TeambookCheckbox checked={mobileHidden} onChange={() => setMobileHidden(!mobileHidden)} />
      </div>
    </>
  );
};

HideMobileSwitch.propTypes = {
  mobileHidden: PropTypes.bool.isRequired,
  setMobileHidden: PropTypes.func.isRequired,
};

export default HideMobileSwitch;
